module.exports = __webpack_public_path__ + "img/rzcg-png.da365d7f.png";